// extracted by mini-css-extract-plugin
export default {"OrderThankYou":"BX29B1dMJj","OrderThankYouContent":"GBqKlb8dMb","ErrorMessage":"KVs4toMQ3x","GoToAccount":"EXSHRq5v4W","DealerMap":"orzfya67bp"};